import { getSymbolCurrency } from "@/js/currency/currencies.js";
import { formRules } from "@/js/form_rules.js";
export default {
  name: "CreditNoteRefundDialog",
  props: {
    creditNote: {
      type: Object
    },
    confirm: Function,
    cancel: Function,
    dialog: Boolean
  },
  data: function data(_this) {
    return {
      validating: false,
      form: {
        refundingNote: "",
        date: new Date().formatForDatePickerDays(),
        amountCurrency: _this.creditNote.remaining.amountCurrency,
        amountExVatCurrency: _this.creditNote.remaining.amountExVatCurrency
      },
      dateMenu: null,
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      rules: formRules
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var _this2 = this;
      var nullishPredicate = function nullishPredicate(x) {
        return x.refundingNote === "" || x.date === "" || x.amountCurrency <= 0 || x.amountCurrency > _this2.creditNote.remaining.amountCurrency;
      };
      if (nullishPredicate(this.form)) return true;
      return false;
    }
  },
  methods: {
    getSymbolCurrency: getSymbolCurrency,
    changeAmountCurrency: function changeAmountCurrency() {
      if (this.form.amountCurrency > this.creditNote.remaining.amountCurrency) {
        this.form.amountCurrency = this.creditNote.remaining.amountCurrency;
      }
    },
    agree: function agree() {
      this.validating = true;
      var _this = this;
      return this.confirm(_this.form.refundingNote, _this.form.date, _this.form.amountCurrency).then(function () {
        _this.validating = false;
        _this.form.refundingNote = "";
        _this.form.date = new Date().formatForDatePickerDays();
        _this.form.amountCurrency = 0.0;
      }).catch(function (e) {
        var _e$response;
        if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && _e$response.data) {
          _this.$toasted.show(e.response.data.value, {
            type: "warning"
          });
        }
        _this.validating = false;
        _this.form.refundingNote = "";
        _this.form.date = new Date().formatForDatePickerDays();
        _this.form.amountCurrency = 0.0;
      });
    },
    internalCancel: function internalCancel() {
      this.form.refundingNote = "";
      this.form.date = new Date().formatForDatePickerDays();
      this.form.amountCurrency = 0.0;
      this.cancel();
    }
  }
};